export const EMAIL_REGEXP =
  /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
export const IP_ADDRESS_REGEXP =
  /^(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])){3}$/;
export const PORT_REGEXP =
  /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;

export const HTTP_URL_REGEXP = /^https?:\/\//i;
export const RTMP_URL_REGEXP = /^rtmps?:\/\//i;
export const RTSP_URL_REGEXP = /^rtsps?:\/\//i;
export const WS_URL_REGEXP = /^wss?:\/\//i;

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*\\.])(?=.{8,})/;

export const ALPHANUMERIC_REGEX = /^[A-Za-z0-9 ]*$/;

export const ALPHA_REGEX = /^[A-Za-z ]*$/;

export const NUMERIC_REGEX = /^[0-9]+$/;
export const TIME_REGEX = /\b((1[0-2]|0?[1-9]):([0-5][0-9]) ([AaPp][Mm]))/;

export const EMOJI_REGEX = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;
